export default "__VITE_ASSET__C0Os01xe__"